import Tooltip from "../generic-building-blocks/Tooltip";
import { Badge } from "@avenueops/web-components";
import { WorkflowStatus } from "@prisma/client";
import React from "react";

interface Props {
  workflowStatus: WorkflowStatus;
  failureReason?: string;
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

export default function WorkflowStatusTag({ workflowStatus, failureReason, size = "SMALL" }: Props) {
  return (
    <div className="font-medium">
      {workflowStatus === WorkflowStatus.READY ? (
        <Badge size={size} type="CUSTOM" className="text-green-800 bg-green-100">
          Active
        </Badge>
      ) : workflowStatus === WorkflowStatus.PAUSED ? (
        <Badge size={size} type="CUSTOM" className="text-gray-800 bg-gray-200">
          Paused
        </Badge>
      ) : workflowStatus === WorkflowStatus.INDEXING || workflowStatus === WorkflowStatus.READY_TO_INDEX ? (
        <Badge size={size} type="CUSTOM" className="text-blue-800 bg-blue-100">
          Verifying...
        </Badge>
      ) : workflowStatus === WorkflowStatus.RETRYING ? (
        <Badge size={size} type="CUSTOM" className="text-indigo-800 bg-indigo-100">
          Retrying...
        </Badge>
      ) : workflowStatus == WorkflowStatus.PAUSED_DATASOURCE ? (
        <Badge size={size} type="CUSTOM" className="text-purple-800 bg-pink-100">
          Paused Data Source
        </Badge>
      ) : (
        <Badge size={size} type="CUSTOM" className="text-red-500 bg-red-100" tooltip={failureReason}>
          Failed!
        </Badge>
      )}
    </div>
  );
}
